/*
 * @Author       : Zhelin Cheng
 * @Date         : 2021-10-12 14:35:54
 * @LastEditors  : Zhelin Cheng
 * @LastEditTime : 2021-11-10 15:01:54
 * @FilePath     : /marketing-introduce-ssr/sentry.client.config.js
 * @Description  : 客户端sentry配置
 */

// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

// import { ignoreErrors, denyUrls } from '@woulsl/sentry-config'
import * as Sentry from '@sentry/nextjs';
import axios from 'axios';
import Cookie from 'js-cookie';
import getConfig from 'next/config';

import { envName, sentryDsn } from './project.config';
import { getCurrPlatformText } from './utils';

const { publicRuntimeConfig } = getConfig() || {};

const _envName = publicRuntimeConfig?.envName || envName || 'pro';
const isPro = _envName === 'pro';

// 设置平台
getCurrPlatformText()
  .then((platform) => {
    const { pathname, search } = window.location;
    Sentry.setTags({
      platform,
      pathname,
      search
    });
  })
  .catch((e) => {
    console.error(e);
  });

// 设置用户UID
const uid = Cookie.get('uid');
if (uid) {
  Sentry.setUser({
    id: uid
  });
}

Sentry.init({
  dsn: sentryDsn,
  environment: _envName,
  sampleRate: isPro ? 0.5 : 1,
  tracesSampleRate: isPro ? 0.25 : 1,
  // sentry错误：axios错误降级
  beforeSend(event, hint) {
    const ev = event || {};
    const err = hint.originalException;
    // 这里可以根据错误信息或 hint 进行修改
    if (axios.isAxiosError(err)) {
      if (err?.config?.url?.indexOf('flagd.evaluation.v1.Service/Resolve') > -1) {
        return null; // ❌ 返回 null = 不上报
      }
      ev.level = 'warning'; // ✅ 统一调整 Axios 错误的上报等级
    }
    return ev;
  },
  ignoreErrors: [
    'onAndroidBack is not defined',
    "Cannot read properties of undefined (reading 'event')",
    'Event `XMLHttpRequestProgressEvent` (type=error) captured as promise rejection',
    /\s*null is not an object \(evaluating 'e\.width'\)\s*/i,
    // 忽略 Cannot read properties of null (reading 'width') 字符串
    /\s*Cannot read properties of null \(reading '(\w+)'\)\s*/i,
    // 正则忽略该错误
    /\s*WebViewJavascriptBridge is not defined\s*/i,
    // 排查发现全局没有使用callJSTypeBack，应该是安卓内部默认桥的问题，可忽略
    /\s*callJSTypeBack is not defined\s*/i,
    // 忽略超时错误
    /\s*Request aborted\s*/i,
    // 忽略超时错误
    /\s*timeout of (\d+)ms exceeded\s*/i,
    // 忽略非错误异常
    /.*Non-Error exception captured with keys\s*:?\s*([\w,\s]+)?.*/i,
    /\s*Network Error\s*/i,
    /\s*Network request failed\s*/i
  ]
});
